/* eslint-disable medely/noColorLiterals */
export type PaletteColors<T extends string> = Record<T, string>;
export type MedelyPalette = {
  state: Record<'info' | 'success' | 'warning' | 'error' | 'teal', StatePalette>;
  surface: SurfacePalette;
  controls: ControlsPalette;
  text: TextPalette;
};

export type StatePalette = PaletteColors<'primary' | 'secondary' | 'backing' | 'backing-1'>;
export type SurfacePalette = PaletteColors<
  'backing-1' | 'secondary' | 'hover+focused' | 'pressed' | 'paper'
>;
export type ControlsPalette = PaletteColors<'backing+line' | 'outline' | 'primary'>;
export type TextPalette = PaletteColors<'primary' | 'secondary' | 'disabled'>;

export const palette: MedelyPalette = {
  state: {
    info: {
      primary: '#012438',
      secondary: '#015582',
      backing: '#f1f9fd',
      'backing-1': '#d9ecf8',
    },
    success: {
      primary: '#00271c',
      secondary: '#005c40',
      backing: '#f1fcf9',
      'backing-1': '#daf4ee',
    },
    warning: {
      primary: '#321f08',
      secondary: '#704700',
      backing: '#fffbf4',
      'backing-1': '#f6eee0',
    },
    error: {
      primary: '#40120d',
      secondary: '#952a1f',
      backing: '#fdf9f9',
      'backing-1': '#faeaea',
    },
    teal: {
      primary: '#004e5a',
      secondary: '#318d98',
      backing: '#f1fbfb',
      'backing-1': '#d6f4f3',
    },
  },
  surface: {
    'backing-1': '#f5f5f5',
    secondary: '#fbfbfb',
    'hover+focused': '#EBEBEB',
    pressed: '#C9C9C9',
    paper: '#ffffff',
  },
  controls: {
    'backing+line': '#ebebeb',
    outline: '#c9c9c9',
    primary: '#898989',
  },
  text: {
    primary: '#202020',
    secondary: '#424242',
    disabled: '#898989',
  },
};

/**
 * Creates a union type of all paths in an object type
 * For example:
 * {
 *     foo: {
 *         bar: string
 *     },
 *     baz: string
 * }
 * Would result in:
 * 'foo.bar' | 'baz'
 */
type TerminalPathsOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}.${TerminalPathsOf<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

export type TextColorKeys = TerminalPathsOf<MedelyPalette['text']>;
export type DesignTokenColor = TerminalPathsOf<MedelyPalette>;
